<template lang="pug">
.Layers
  .Layers-menu.Menu.ExcelLayerList-top-panel
    .Menu-left.ExcelLayerList-layer-count
      | Количество слоёв: {{ list ? list.length : "0" }}
    text-box.ExcelLayerList-search-text-box(
      placeholder='Введите название слоя для поиска',
      :value='searchText',
      @valueChanged='searchTextChanged'
    )
    .Menu-right.ExcelLayerList-add-button-wrapper
      router-link.Btn.Btn--transparent.Btn--light.BtnIcon(
        v-if='permissions.canCreateAggregateInfoLayer',
        tag='button',
        :to='{ name: "excel-layer-settings", params: { layerId: "new" } }'
      )
        i.Icon.IconPlus
        | Добавить слой
  .Layers-main
    .Layers-spinner
      fade-loader.Spinner(
        :loading='isInitLoading || isLoadingLayers',
        color='#27bd8a',
        height='8px',
        width='3px',
        radius='10px'
      )
    .Layers-empty(v-if='!isInitLoading && !isLoadingLayers && list && list.length === 0') Список слоев пуст
    .Layers-list.LayerList(v-if='!isInitLoading && !isLoadingLayers && list && list.length > 0')
      .Layers-item.LayerItem.Card(
        :key='item.id',
        v-for='item in list'
      )
        .LayerItem-spinnerwrapper(v-if='isDownloading[item.id]')
          .LayerItem-spinner
            fade-loader.Spinner(
              :loading='isDownloading[item.id]',
              color='#27bd8a',
              height='8px',
              width='3px',
              radius='10px'
            )
        .LayerItem-main
          .LayerItem-top
            .LayerItem-title {{ item.name }}
            .LayerItem-description(v-if='item.is_integration') Интегрированный
            .LayerItem-description(v-if='item.status === "working" || item.status === "new"') Слой находится в процессе обработки
            .LayerItem-description.LayerItem-description--error(v-if='item.status === "error"') Обработка слоя завершилась ошибкой
          .LayerItem-footer
            //.LayerItem-info(v-if="item.date || item.size")
              .LayerItem-date {{item.size}}
              .LayerItem-dot(v-if="item.date && item.size")
              .LayerItem-size {{item.date}}
            .LayerItem-actions.Actions
              .Actions-item.Pointer(
                v-if='getParsedItemLog(item)',
                @click='openLog(item)',
                @mouseover='$store.commit("setHelperType", "Журнал создания слоя")',
                @mouseout='$store.commit("setHelperType", "")'
              )
                i.Icon.IconLog
              .Actions-item.Pointer(
                v-if='item.status === "finished"',
                @click='toggleLayerVisibility(item)',
                @mouseover='visibilityButtonMouseOver(item)',
                @mouseout='$store.commit("setHelperType", "")'
              )
                i.Icon(:class='{ IconVisible: item.active, IconHidden: !item.active }')
              .Actions-item.Pointer(
                v-if='item.status === "finished"',
                @click='goToExcelObjectList(item)',
                @mouseover='$store.commit("setHelperType", "Открыть таблицу объектов слоя")',
                @mouseout='$store.commit("setHelperType", "")'
              )
                i.Icon.IconOpenDocument
              .Actions-item.Pointer(
                v-if='item.status === "finished"',
                @click='downloadFile(item)',
                @mouseover='$store.commit("setHelperType", "Скачать файл")',
                @mouseout='$store.commit("setHelperType", "")'
              )
                i.Icon.IconDownload
              .Actions-item.Pointer(
                v-if='permissions.canCreateAggregateInfoLayer || permissions.canEditAggregateInfoLayer || permissions.canDeleteAggregateInfoLayer',
                @mouseover.stop='helperText = "Дополнительные функции"',
                @mouseout.stop='helperText = null'
              )
                i.Icon.IconDots
                .Actions-list.List(@mouseover.stop='helperText = null')
                  .List-item(
                    v-if='!item.is_integration && item.status === "finished" && permissions.canCreateAggregateInfoLayer',
                    @click='addObject(item.id)'
                  ) Добавить объект
                  router-link.List-item(
                    v-if='item.status === "finished" && permissions.canEditAggregateInfoLayer',
                    tag='div',
                    :to='{ name: "excel-layer-settings", params: { layerId: item.id } }'
                  ) Настройки
                  .List-item(
                    v-if='permissions.canDeleteAggregateInfoLayer',
                    @click='removeLayer(item.id)'
                  ) Удалить
</template>

<script>
import ExcelLayerObject from '@/components/popups/ExcelLayerObject'
import LogPopup from '@/components/popups/Log'
import common from '@/mixins/common'
import helpertext from '@/mixins/helpertext'
import TextBox from '@/components/TextBox.vue'

export default {
  name: 'excel-layer-list',

  mixins: [common, helpertext],

  components: {
    TextBox,
    'fade-loader': () => import('vue-spinner/src/FadeLoader.vue')
  },

  data() {
    return {
      isDownloading: {},
      isLoadingLayers: false,
      headersMap: {},
      getLayersTimeout: null,
      searchText: ''
    }
  },

  computed: {
    sortedExcelLayerList() {
      return (this.$store.getters.excelLayerList || []).sort((layer1, layer2) => {
        const name1 = (layer1.name || '').toUpperCase()
        const name2 = (layer2.name || '').toUpperCase()

        if (name1 < name2) {
          return -1
        }
        if (name1 > name2) {
          return 1
        }

        //Если названия равны при приведении к большому регистру, то сравним в исходном регистре
        if (layer1.name < layer2.name) {
          return -1
        }
        if (layer1.name > layer2.name) {
          return 1
        }

        return 0
      })
    },

    list() {
      if (!this.searchText) {
        return this.sortedExcelLayerList
      }

      return this.sortedExcelLayerList.filter((layerSettings) => {
        if (typeof layerSettings.name !== 'string') {
          return false
        }

        return layerSettings.name.toUpperCase().includes(this.searchText.toUpperCase())
      })
    },

    isInitLoading() {
      return this.$store.getters.isInitLoading
    },

    permissions() {
      return this.$store.getters.permissions
    }
  },

  watch: {
    workspaceAndVersion(newVal, oldVal) {
      this.getLayers()
    }
  },

  mounted() {
    this.getLayers()
  },

  beforeDestroy() {
    clearTimeout(this.getLayersTimeout)
    this.$store.commit('setExcelLayersKeyValue', {
      key: 'excelLayerList',
      value: null
    })
  },

  methods: {
    addObject(layerId) {
      if (this.headersMap[layerId]) {
        this.openPopup(layerId)
      } else {
        this.$store.dispatch('getExcelLayerSettings', { id: layerId }).then((infoLayerSettings) => {
          this.headersMap[layerId] = infoLayerSettings.headers
          this.openPopup(layerId)
        })
      }
    },
    openPopup(layerId) {
      this.$ui.popup.show({
        component: ExcelLayerObject,
        params: {
          width: '734px',
          headers: this.headersMap[layerId],
          layerId: layerId + '',
          title: 'Добавить запись'
        }
      })
    },
    getLayers(loading = true) {
      this.isLoadingLayers = loading
      this.$store
        .dispatch('getExcelLayerList', { offset: 0 })
        .then((r) => {
          this.isLoadingLayers = false
          if (this.list.filter((v) => v.status === 'working' || v.status === 'new').length > 0) {
            clearTimeout(this.getLayersTimeout)
            this.getLayersTimeout = setTimeout(() => {
              this.getLayers(false)
            }, 10000)
          }
        })
        .catch((e) => {
          this.isLoadingLayers = false
        })
    },
    removeLayer(id) {
      this.$store
        .dispatch('deleteExcelObject', {
          id
        })
        .then((v) => {
          this.$ui.toast.show({ text: 'Слой и все его записи удалены', time: '5000', type: 'success' })
          this.getLayers()
        })
        .catch((e) => {
          this.$ui.toast.show({ text: 'Ошибка удаления слоя и его записей', time: '5000', type: 'error' })
        })
    },
    downloadFile(item) {
      const id = item.id
      const date = new Date()
      const name = `${item.name}_${date.toLocaleDateString()}_${date.toLocaleTimeString([], {
        timeStyle: 'short'
      })}.xlsx`

      this.isDownloading = { ...this.isDownloading, [id]: true }
      this.$store
        .dispatch('getExcelLayerFile', {
          id,
          name
        })
        .then((r) => {
          this.isDownloading = { ...this.isDownloading, [id]: false }
        })
        .catch((e) => {
          this.isDownloading = { ...this.isDownloading, [id]: false }
        })
    },

    /**
     * Обработка лога слоя
     */
    getParsedItemLog(item) {
      if (!item.log) {
        return null
      }

      //Задача https://app.clickup.com/t/2unkb3u.
      //Убираем из лога финальное сообщение
      return item.log.replace('Слой загружен успешно', '')
    },

    openLog(item) {
      this.$ui.popup.show({
        component: LogPopup,
        params: {
          title: item.name,
          text: this.getParsedItemLog(item)
        }
      })
    },

    /**
     * Переход к списку объектов слоя
     */
    goToExcelObjectList(item) {
      this.$store.commit('setHelperType', '')
      this.$router.push({
        name: 'excel-object-list',
        params: {
          layerId: item.id
        }
      })
    },

    searchTextChanged(value) {
      if (this.searchTimeout) {
        window.clearTimeout(this.searchTimeout)
        this.searchTimeout = null
      }

      this.searchTimeout = window.setTimeout(() => {
        this.searchText = value
      }, 400)
    },

    visibilityButtonMouseOver(layerItem) {
      const helperText = layerItem.active ? 'Отключить видимость слоя на карте' : 'Включить видимость слоя на карте'
      this.$store.commit('setHelperType', helperText)
    },

    /**
     * Переключение видимости слоя на карте при открытии карты
     */
    toggleLayerVisibility(layerItem) {
      //Сначала запросим полные настройки слоя, чтобы при сохранении не сбить ничего
      this.$store
        .dispatch('loadExcelLayerSettings', {
          id: layerItem.id
        })
        .then((layerSettings) => {
          if (!layerSettings) {
            return null
          }

          //Сохранение настроек слоя
          let params = {
            ...layerSettings,
            icon_id: layerSettings.icon,
            active: !layerSettings.active
          }
          delete params.icon

          return this.$store.dispatch('updateExcelLayerSettings', {
            id: layerSettings.id,
            params
          })
        })
        .then(() => {
          const text = layerItem.active ? 'Отключена видимость слоя на карте' : 'Включена видимость слоя на карте'
          this.$ui.toast.show({ text, time: '5000', type: 'success' })

          //Изменим значение флага во vuex чтобы в интерфейсе поменялась кнопка
          this.$store.commit('setExcelLayerField', {
            layerId: layerItem.id,
            fieldName: 'active',
            fieldValue: !layerItem.active
          })
        })
        .catch(() => {
          this.$ui.toast.show({ text: 'Ошибка сохранения настроек слоя', time: '5000', type: 'error' })
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import '~base';

#app .Layers {
  --itemBg: #{$white2};
  --accentColor: #{$blue};
  --titleColor: #{$black5};
  --hoveredBg: #{$grey7};
  --itemShadow: rgba(96, 104, 115, 0.2);
  --descriptionColor: #{$grey8};
  --listBg: #{$white2};
  --listBorder: #{$white2};
  --btnBorderColor: #{$grey3};
  --btnTextColor: #{$blue};
  --btnBg: transparent;
  --menuColor: #{$grey8};
  --menuLinkColor: #{$blue};
}

#app[data-theme='dark'] .Layers {
  --itemBg: #{$black3};
  --accentColor: #{$blue};
  --descriptionColor: #{$grey5};
  --titleColor: #{$white3};
  --hoveredBg: #{$black3};
  --listBg: #{$grey2};
  --listBorder: #{$grey8};
  --itemShadow: transparent;
  --btnBorderColor: transparent;
  --btnTextColor: #{$white3};
  --btnBg: #{$blue};
  --menuColor: #{$grey1};
  --menuLinkColor: #{$blue};
}
.Layers {
  display: flex;
  flex-direction: column;
  height: 100%;

  &-menu {
    flex: 0 0 35px;
  }

  &-spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -16px 0 0 -16px;
  }

  &-empty {
    font-size: 14px;
    padding: 15px 0;
  }

  &-main {
    flex: 1 1 auto;
    padding: 0 15px 50px;
    background: var(--appBg);
    overflow: auto;
  }

  &-list {
    display: flex;
    margin-left: -2%;
    flex-wrap: wrap;
  }
}

.Menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 35px;
  padding: 0 15px;
  color: var(--menuColor);
  font-size: 12px;
  border-bottom: 1px solid var(--delimiter);

  &-right {
    button {
      display: flex;
      align-items: center;
      color: var(--menuLinkColor);

      .Icon {
        margin-right: 10px;
        font-size: 14px;
      }
    }
  }

  &-delimiter {
    width: 1px;
    height: 24px;
    background: var(--delimiter);
  }
}

.LayerItem {
  display: flex;
  position: relative;
  align-items: flex-start;
  padding: 15px;
  background: var(--itemBg);
  box-shadow: 0px 0px 4px var(--itemShadow);

  &-spinnerwrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: var(--appBg);
    z-index: 10;
  }

  &-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -5px 0 0 -5px;
    z-index: 10;
  }

  &-select {
    flex: 0 0 auto;
    margin-right: 5px;
  }

  &-title {
    color: var(--titleColor);
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
    word-wrap: break-word;
  }

  &-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 24px;
    min-height: 24px;
  }

  &-info {
    font-size: 12px;
    color: var(--secondaryText);

    & > * {
      display: inline-block;
      margin-right: 7px;
    }
  }

  &-dot {
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: var(--secondaryText);
    vertical-align: 3px;
  }

  &-main {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    max-width: 100%;
  }
  &-description {
    margin-top: 10px;
    color: var(--descriptionColor);
    font-size: 12px;

    &--error {
      color: $red;
    }
  }

  &.Pointer:hover &-title {
    color: var(--accentColor);
  }
}

.Actions {
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-end;
  align-items: center;

  .Icon {
    color: var(--secondaryText);
  }

  &-item {
    display: block;
    flex: 0 0 40px;
    position: relative;
    text-align: right;
    text-decoration: none;

    &:last-child {
      flex: 0 0 35px;
    }

    &:hover {
      .Icon {
        color: var(--accentColor);
      }
    }

    .IconVisible {
      font-size: 12px;
    }

    .IconHidden {
      font-size: 14px;
    }
  }

  &-list {
    position: absolute;
    display: none;
    z-index: 15;
    right: 0;
    top: 100%;
    width: 233px;
    background: var(--listBg);
    border: 1px solid var(--listBorder);
    text-align: right;
    box-shadow: 0px 0px 4px rgba(96, 104, 115, 0.2);
  }

  &-item:hover &-list {
    display: block;
  }
}

.List {
  &-item {
    padding: 0 10px;
    font-size: 14px;
    line-height: 36px;
    cursor: pointer;
    font-weight: 500;
    color: var(--titleColor);

    &:hover {
      background: var(--hoveredBg);
    }
  }
}

.ExcelLayerList {
  &-top-panel {
    justify-content: flex-start;
    gap: 10px;
  }

  &-layer-count {
    flex: 0 0 auto;
    white-space: nowrap;
    padding-top: 3px; /**Чтобы выровнять текст по вертикали со строкой поиска */
  }

  &-search-text-box {
    flex: 0 0 350px;
  }

  &-add-button-wrapper {
    flex: 1 1 auto;
    display: flex;
    justify-content: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/excel-layers/ExcelLayerList.vue